/* global axios */
import ApiClient from './ApiClient';

class AssignableAgents extends ApiClient {
  constructor() {
    super('assignable_agents', { accountScoped: true });
  }

  get(inboxIds, options = {}) {
    const { signal } = options;
    return axios.get(this.url, {
      params: { inbox_ids: inboxIds },
      signal,
    });
  }
}

export default new AssignableAgents();
